import React from "react";
import AppInit from "../AppInit";
import NiceModal from "@ebay/nice-modal-react";
import CONFIG from "../model/TSConfig";
import { BrowserRouter } from "react-router-dom";

function AppRouterWrapper() {
  return (
    <BrowserRouter basename={CONFIG.baseName}>
      <NiceModal.Provider>
        <AppInit />
      </NiceModal.Provider>
    </BrowserRouter>
  );
}

export default AppRouterWrapper;
